import request from '@/services/request';
import {baseApi} from '../config'
/**
 * @description 兑换码兑换
 */
export const exchange=(params:any)=>{
  return request.post(`${baseApi}/exchangeCode/exchange`,params)
}
/**
 * @description 我的订单列表
 */
export const getMyOrder=(params:any)=>{
  return request.post(`${baseApi}/cost/getMyOrder`,params)
}
/**
 * @description 我的收藏列表
 */
export const contentCollectionList=(params:any)=>{
  return request.post(`${baseApi}/user/contentCollectionList`,params)
}